/* created by CoolGuy on 2018/11/26
 * 特殊红包 */
import React from "react";
import Wrapper from "./Wrapper";
import { inject, observer } from "mobx-react";
import { observable, action } from "mobx";
import { debounce } from "../../utils/util";
import imageUtil from "../../utils/image";
import intl from "react-intl-universal";

const getRealPhoto = (photo) => {
  if (!photo) {
    return "";
  }
  if (photo.indexOf("http") === 0 || photo.indexOf("//") === 0) {
    return photo;
  }
  return imageUtil.style(photo, "redpackage_logo");
};

const ValidContent = ({
  content,
  postname,
  postphoto,
  onSubmit,
  status,
  toDetail,
  access_type,
}) => (
  <div className="special-bottom">
    <div className={"special-bottom-main-content"}>
      <div className="the-content">{content}</div>
    </div>
    <img
      src={
        postphoto
          ? getRealPhoto(postphoto)
          : require("../../assets/jf-logo.png")
      }
      alt=""
      className={"branch-logo"}
    />
    <div className={"post-name"}>{postname || "即享影像"}</div>
    {status === "done" ? (
      <div onClick={toDetail} style={{ fontSize: 12 }}>
        {intl.get("View details")}
      </div>
    ) : (
      <button
        className={"special-bottom-btn"}
        onClick={debounce(onSubmit)}
        style={access_type === "limit" ? { fontSize: 14 } : {}}
      >
        {access_type === "limit"
          ? intl.get("Limited Red Packet")
          : intl.get("Open Red Packet")}
      </button>
    )}
  </div>
);

const InValidContent = ({ content, postname, postphoto, toDetail }) => (
  <div className="special-bottom">
    <div className={"special-bottom-main-content invalid"}>
      <p>{intl.get("You're too slow")}</p>
      <p>{intl.get("Better luck next time")}</p>
    </div>
    <img
      src={
        postphoto
          ? getRealPhoto(postphoto)
          : require("../../assets/jf-logo.png")
      }
      alt=""
      className={"branch-logo"}
    />
    <div className={"post-name"}>{postname || "即享影像"}</div>
    <div onClick={toDetail} style={{ fontSize: 12 }}>
      {intl.get("View details")}
    </div>
  </div>
);

let askStatus = {};

@inject("rootStore")
@observer
class Special extends React.Component {
  @observable status = "";
  @observable access_type = "";
  askTheRedPack = (id) => {
    if (id && !askStatus[String(id)]) {
      const { redPackStore } = this.props.rootStore;

      askStatus[String(id)] = true;
      redPackStore.askRedPack(id).then(
        action((jsonData) => {
          const { status, access_type } = jsonData;
          this.status = status;
          this.access_type = access_type;
          // end或者done的红包直接写到本地，不需要重新被唤醒了
          if (status === "end" || status === "done") {
            redPackStore.saveToGotRedPackList(this.props.id);
          }

          askStatus[String(id)] = false;
        })
      );
    } else {
      console.warn("id is null or is pending now", id);
    }
  };
  toDetail = debounce(() => {
    this.props.rootStore.redPackStore.setRedPackDetailModal(this.props.id);
  });

  componentWillReceiveProps(nextProps) {
    //console.log(nextProps,'Special will receive props')
    this.askTheRedPack(nextProps.id);
  }
  componentDidMount() {
    //console.log(this.props,'Special did mount');
    this.askTheRedPack(this.props.id);
  }
  render() {
    const { props } = this;
    if (!this.status) {
      return null;
    }
    return (
      <Wrapper onClose={props.onClose}>
        {this.status === "end" || this.status === "close" ? (
          <InValidContent {...props} toDetail={this.toDetail} />
        ) : (
          <ValidContent
            {...props}
            status={this.status}
            access_type={this.access_type}
            toDetail={this.toDetail}
          />
        )}
      </Wrapper>
    );
  }
}
export default Special;
